import React, { useState, useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';
import { Box } from '@mui/material';

const UniversalTooltip = ({
  anchorRef,
  open,
  onClose,
  children,
  offset = { x: 0, y: 0 },
}) => {
  const tooltipRef = useRef(null);
  const [position, setPosition] = useState({ top: 0, left: 0 });
  const [hovering, setHovering] = useState(false);

  useEffect(() => {
    if ((open || hovering) && anchorRef.current && tooltipRef.current) {
      const rect = anchorRef.current.getBoundingClientRect();

      setPosition({
        top: rect.bottom + offset.y,
        left: rect.left + offset.x,
      });
    }
  }, [open, hovering, anchorRef, offset]);

  useEffect(() => {
    if (!open && !hovering) return;
    if (!hovering && !open) onClose?.();
  }, [hovering, open, onClose]);

  if (!open && !hovering) return null;

  return ReactDOM.createPortal(
    <Box
      ref={tooltipRef}
      onMouseEnter={() => setHovering(true)}
      onMouseLeave={() => setHovering(false)}
      sx={{
        position: 'fixed',
        top: position.top,
        left: position.left,
        zIndex: 1500,
        backgroundColor: 'background.paper',
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: 1,
        padding: 1,
        boxShadow: 3,
        maxWidth: 360,
        maxHeight: 'max-content',
        overflowY: 'auto',
      }}
    >
      {children}
    </Box>,
    document.body
  );
};

export default UniversalTooltip;
